import FeatureGates, {
    ClientOptions,
    FeatureGateEnvironment,
    Identifiers,
    CustomAttributes,
} from "@atlassian/feature-gate-js-client";
import { FeatureGatesInitialization } from "@atlassian/feature-gates-react";
import { PropsWithChildren } from "react";

// wac statsig api keys - https://developer.atlassian.com/platform/frontend-feature-flags/resources/api-keys/#statsig-only-supported
const EnvironmentApiKeyMapping = new Map([
    [
        FeatureGateEnvironment.Development,
        "ab9944a4-9eb2-482b-b997-36f41f3a1edf",
    ],
    [FeatureGateEnvironment.Staging, "ff9c70b0-ab7e-4abc-be4f-53f9c3fd37d6"],
    [FeatureGateEnvironment.Production, "4e18bcb9-52fb-4f76-b7b6-a0d9d8e56f8f"],
]);

/**
 * Initializes the feature gate client with the given configuration values.
 * @param @FeatureGateProps
 */
export const FeatureGatesInitializationProvider = ({
    environment,
    identifiers,
    customAttributes,
    initializingComponent,
    clientOptions = {} as ClientOptions,
    children,
}: FeatureGateProps) => {
    const apiKey = EnvironmentApiKeyMapping.get(environment) ?? "";

    return (
        <FeatureGatesInitialization
            enabled={true}
            options={{
                ...clientOptions,
                apiKey,
                environment,
            }}
            identifiers={identifiers}
            customAttributes={customAttributes}
            initializingComponent={initializingComponent}
        >
            {children}
        </FeatureGatesInitialization>
    );
};

export type FeatureGateProps = PropsWithChildren<{
    environment: FeatureGateEnvironment;
    identifiers: Identifiers;
    customAttributes?: CustomAttributes;
    initializingComponent?: JSX.Element;
    clientOptions?: ClientOptions;
}>;

export const Experiments = FeatureGates;
